import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AboutView from '../views/AboutView.vue';
import WaitingRoom from '../views/WaitingRoom.vue';
import AdminPatient from '../views/Admin-Patients.vue';
import AdminParametre from '../views/Admin-Parametre.vue';

import login from '../views/Login-Admin.vue';
import inscription from '../views/inscription-client.vue'

// Définir vos routes
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/inscription',
    name: 'inscription',
    component: inscription
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },

  {
    path: '/AdminPatient',
    name: 'AdminPatient',
    component: AdminPatient
  },
  {
    path: '/AdminParametre',
    name: 'AdminParametre',
    component: AdminParametre
  },
  {
    path: '/waiting-room',
    name: 'waiting-room',
    component: WaitingRoom
  }
];

// Créer le routeur
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Garde de navigation pour vérifier l'authentification
router.beforeEach((to, from, next) => {
  // Vérifiez si le token est valide
  const token = localStorage.getItem('auth_token'); // Ou utilisez une autre méthode pour récupérer le token
  const isPublicRoute = to.name === 'waiting-room' || to.name === 'login' || to.name === 'inscription';

  if (!token && !isPublicRoute) {
    // Si pas de token et pas sur une route publique, redirigez vers la page de connexion
    next({ name: 'login' });
  } else {
    // Sinon, continuez vers la route souhaitée
    next();
  }
});

export default router;
